// A2F-764: top header strip for /pro-v2.
//
// Logo + wordmark + "CONFIGURATOR · PRO" subtext on the left,
// "Returning user? Sign in" link on the right. Lives outside the
// scroll container so it stays visible while the left column scrolls.

import { Link } from 'react-router-dom'
import logoUrl from '../../../../assets/icon-80.png?url'

export function ProV2Header() {
  return (
    <header className="sticky top-0 z-20 flex items-center justify-between bg-white border-b border-slate-200 px-6 py-3">
      <div className="flex items-center gap-2.5">
        <img src={logoUrl} alt="" className="h-7 w-7 object-contain" />
        <span className="font-bold text-sm text-brand-charcoal tracking-wide">
          CHRONA
        </span>
        <span className="text-[10px] font-semibold text-brand-orange tracking-[0.18em] uppercase border-l border-slate-200 pl-2.5">
          Configurator · Pro
        </span>
      </div>
      <div className="text-[12px] text-slate-500 flex items-center gap-2">
        <span className="hidden sm:inline">Returning user?</span>
        <Link
          to="/configure"
          className="text-brand-orange font-medium hover:underline"
        >
          Sign in
        </Link>
      </div>
    </header>
  )
}
